export class CheckInItem {
    public agentId: number;
    public appointmentId: string;
    public appointmentDate: Date;
    public businessTransactionNumberId: number;
    public businessTransactionTypeValue: string;
    public businessTransactionTypeId: number;
    public businessTransactionWipStatusId: number;
    public businessUnitId: string;
    public businessUnitName: string;
    public details: string;
    public disabled: boolean;
    public firstName: string;
    public lastName: string;
    public name: string;
    public transactionValidationMode: number;
    public wipStatusTypeValue: string;
}
